<template>
    <!--   场地管理－优惠券管理 - 优惠券使用记录 -->
    <div>
    <content-view>
        <div slot="header">

        <a-form :form="form" layout="inline" class="store-one-form">
            <a-form-item label="用户账号">
                <a-input placeholder="请输入" v-decorator="['account']"></a-input>
            </a-form-item>
            <a-form-item label="优惠券状态">
                <a-select allowClear placeholder="请选择" v-decorator="['couponStatus']">
                    <a-select-option value="1">未使用</a-select-option>
                    <a-select-option value="2">已使用</a-select-option>
                    <a-select-option value="3">已禁用</a-select-option>
                    <a-select-option value="4">已过期</a-select-option>
                    <a-select-option value="5">已失效</a-select-option>
                    <a-select-option value="6">已锁定</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="领取时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY-MM-DD"
                    v-decorator="['getTime']"
                />
            </a-form-item>
            <a-form-item label="使用时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY-MM-DD"
                    v-decorator="['useTime']"
                />
            </a-form-item>
            <a-form-item class="wrap-header-button">
                <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                <a-button @click="handleReset">重置</a-button>
            </a-form-item>
        </a-form>
        </div>

        <div class="container">
        <a-alert :message="'已领取'+getNum+'张；已使用'+useNum+'张'" banner />
        <a-table
            class="mt16"
            bordered
            :dataSource="dataSource"
            :columns="columns"
            :pagination="pagination"
            @change="changePage"
            :rowKey="(record,index) => index"
        >
            <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
            <span slot="useTime" slot-scope="useTime">{{useTime ? useTime : "-"}}</span>
            <span slot="action" slot-scope="a,row">
                <a-popconfirm
                    v-if="row.couponStatus == 1"
                    title="确认禁用吗？"
                    @confirm="couponState(row)"
                >
                    <a class="text-primary">禁用</a>
                </a-popconfirm>
                <span v-else class="text-disabled">禁用</span>
            </span>
        </a-table>
        </div>
    </content-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import moment from "moment";
    export default {
        name: "couponShow",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                getNum: undefined,
                useNum: undefined,
            };
        },
        computed: {
            ...mapGetters(["shopId", "shopName"])
        },
        methods: {
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const getTime = values['getTime'] ? values['getTime'] : []
                    values.getStartTime = getTime.length > 0 ? getTime[0].format('YYYY-MM-DD 00:00:00') : undefined
                    values.getEndTime = getTime.length > 0 ? getTime[1].format('YYYY-MM-DD 23:59:59') : undefined

                    const useTime = values['useTime'] ? values['useTime'] : []
                    values.effectiveStartTime = useTime.length > 0 ? useTime[0].format('YYYY-MM-DD 00:00:00') : undefined
                    values.effectiveEndTime = useTime.length > 0 ? useTime[1].format('YYYY-MM-DD 23:59:59') : undefined

                    values.id = this.$route.query.id
                    values.shopId = this.shopId

                    this.$api.changeCode
                        .couponShow({
                            body: Object.assign(values, {
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            })
                        })
                        .then(res => {
                            this.dataSource = res.list
                            this.pagination.total = res.total
                        });
                });
            },
            couponShowCount() {
                this.$api.changeCode.couponShowCount({
                    params: {id: this.$route.query.id}
                })
                .then(res => {
                    this.getNum = res.getNum
                    this.useNum = res.useNum
                })
            },
            couponState(row) {
                this.$api.changeCode.couponState({
                    body: {
                        userCouponNo: row.userCouponNo,
                        userId: row.userId,
                        phone: row.account, 
                        shopId: this.shopId,
                        shopName: this.shopName,
                        platformId: -1,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                    this.couponShowCount();
                })
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
            this.couponShowCount();
        },
        watch: {
            'shopId'() {
                this.getList()
            }
        }
    };
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "用户账号",
        dataIndex: "account"
    },
    {
        title: "领取时间",
        dataIndex: "getTime"
    },
    {
        title: "使用时间",
        dataIndex: "useTime",
        scopedSlots: { customRender: "useTime" }
    },
    {
        title: "优惠券状态",
        dataIndex: "couponStatusName",
        scopedSlots: { customRender: "couponStatus" }
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
</script>
<style lang="scss">
.container {
  background: #fff;
}
</style>